import api from './api';

// Employee — Submit Report
export const submitEthicsReport = (data) => api.post('/v1/ethics-reports/submit', data);

// Employee — My Reports (non-anonymous)
export const getMyEthicsReports = (params) => api.get('/v1/ethics-reports/my', { params });

// Anonymous — Track Report
export const trackEthicsReport = (data) => api.post('/v1/ethics-reports/track', data);
export const sendTrackMessage = (data) => api.post('/v1/ethics-reports/track/message', data);

// Admin — Report Management
export const getAdminEthicsReports = (params) => api.get('/v1/ethics-reports/admin', { params });
export const getAdminEthicsReport = (id) => api.get(`/v1/ethics-reports/admin/${id}`);
export const updateReportStatus = (id, data) => api.put(`/v1/ethics-reports/admin/${id}/status`, data);
export const assignReport = (id, data) => api.put(`/v1/ethics-reports/admin/${id}/assign`, data);
export const updateReportPriority = (id, data) => api.put(`/v1/ethics-reports/admin/${id}/priority`, data);
export const sendAdminMessage = (id, data) => api.post(`/v1/ethics-reports/admin/${id}/messages`, data);
export const getAdminStats = () => api.get('/v1/ethics-reports/admin/stats');

// Categories
export const getEthicsReportCategories = (params) => api.get('/v1/ethics-report-categories', { params });
export const createEthicsReportCategory = (data) => api.post('/v1/ethics-report-categories', data);
export const updateEthicsReportCategory = (id, data) => api.put(`/v1/ethics-report-categories/${id}`, data);
export const deleteEthicsReportCategory = (id) => api.delete(`/v1/ethics-report-categories/${id}`);
